"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBytes32Array = void 0;
const toBytes32Array = (b) => {
    const buf = Buffer.alloc(32);
    b.copy(buf, 32 - b.length);
    return Array.from(buf);
};
exports.toBytes32Array = toBytes32Array;
